document.addEventListener("DOMContentLoaded", () => {
  const TOKYO_DEFAULT = { name: "東京", lat: 35.6762, lng: 139.6503, tz: 9 };

  document.body.classList.add("mode-3d");

  // Safe event binding
  function on(id, event, handler) {
    const el = document.getElementById(id);
    if (el) el.addEventListener(event, handler);
    return el;
  }

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // localStorage persistence of user input
  const STORAGE_KEY = "ravicharme_state_v1";
  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      console.warn("[RAVI] state save failed:", e);
    }
  }
  function loadSavedState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") return parsed;
    } catch (e) {
      console.warn("[RAVI] state load failed:", e);
    }
    return null;
  }
  function clearSavedState() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  const state = {
    birthYear: null,
    birthMonth: null,
    birthDay: null,
    gender: null,
    maritalStatus: null,
    childrenCount: null,
    location: null,
    timeBlock: null,
    purposes: [],
  };

  UI.populateDateSelects();

  // Restore previously saved input into state + UI (does not auto-advance screens)
  const savedState = loadSavedState();
  if (savedState) {
    Object.assign(state, savedState);
    if (state.birthYear != null) {
      const yEl = document.getElementById("birth-year");
      const mEl = document.getElementById("birth-month");
      const dEl = document.getElementById("birth-day");
      if (yEl) yEl.value = state.birthYear;
      if (mEl) mEl.value = state.birthMonth;
      // Trigger day list rebuild for that year+month, then set day
      if (yEl) yEl.dispatchEvent(new Event("change"));
      if (dEl) dEl.value = state.birthDay;
    }
    if (state.timeBlock) {
      const matched = UI.selectCard("#time-simple", "time", state.timeBlock);
      if (!matched) {
        // Fall back to detailed time selection and flip the view
        UI.selectCard("#time-detail", "time", state.timeBlock);
        const simple = document.getElementById("time-simple");
        const detail = document.getElementById("time-detail");
        const btn = document.getElementById("btn-detail-time");
        if (simple && detail && btn) {
          simple.style.display = "none";
          detail.style.display = "";
          btn.textContent = "おおまかに選ぶ";
        }
      }
      UI.showButton("btn-to-gender");
    }
    if (state.gender) {
      UI.selectCard("#screen-gender", "gender", state.gender);
      UI.showButton("btn-to-marital");
    }
    if (state.maritalStatus) {
      UI.selectCard("#screen-marital", "marital", state.maritalStatus);
      const childWrap = document.getElementById("children-count-wrap");
      if (state.maritalStatus === "married" || state.maritalStatus === "single") {
        if (childWrap) childWrap.style.display = "";
        const cs = document.getElementById("children-count");
        if (cs && state.childrenCount != null) cs.value = String(state.childrenCount);
      } else if (childWrap) {
        childWrap.style.display = "none";
      }
      UI.showButton("btn-to-location");
    }
    if (state.location && state.location.name) {
      const locSel = document.getElementById("location-selected");
      const locInput = document.getElementById("location-search");
      if (locInput) locInput.value = state.location.name;
      if (locSel) {
        locSel.textContent = `${state.location.name} を選択`;
        locSel.style.display = "block";
      }
      UI.showButton("btn-to-purpose");
    }
    if (Array.isArray(state.purposes) && state.purposes.length > 0) {
      UI.selectMultiCards("#purpose-grid", "purpose", state.purposes);
      const countEl = document.getElementById("purpose-count");
      if (countEl) countEl.textContent = `${state.purposes.length}つ選択中`;
      UI.showButton("btn-to-result");
    }
    console.log("[RAVI] 保存された入力を復元:", state);
  }

  // Gender card selection
  UI.setupCardSelection("#screen-gender", "gender", (value) => {
    state.gender = value;
    saveState();
    UI.showButton("btn-to-marital");
  });

  // Marital status card selection
  UI.setupCardSelection("#screen-marital", "marital", (value) => {
    state.maritalStatus = value;
    const childWrap = document.getElementById("children-count-wrap");
    if (value === "married" || value === "single") {
      childWrap.style.display = "";
      const childSel = document.getElementById("children-count");
      if (state.childrenCount == null) {
        childSel.value = "0";
        state.childrenCount = 0;
      } else {
        childSel.value = String(state.childrenCount);
      }
    } else {
      childWrap.style.display = "none";
      state.childrenCount = null;
    }
    saveState();
    UI.showButton("btn-to-location");
  });

  // Children count change
  const childrenSelect = document.getElementById("children-count");
  if (childrenSelect) {
    childrenSelect.addEventListener("change", () => {
      state.childrenCount = parseInt(childrenSelect.value) || 0;
      saveState();
    });
  }

  // Time card selection (simple)
  UI.setupCardSelection("#time-simple", "time", (value) => {
    state.timeBlock = value;
    document.querySelectorAll("#time-detail .card--selected").forEach(c => c.classList.remove("card--selected"));
    saveState();
    UI.showButton("btn-to-gender");
  });

  // Time card selection (detailed)
  UI.setupCardSelection("#time-detail", "time", (value) => {
    state.timeBlock = value;
    document.querySelectorAll("#time-simple .card--selected").forEach(c => c.classList.remove("card--selected"));
    saveState();
    UI.showButton("btn-to-gender");
  });

  // Toggle detail time view
  on("btn-detail-time", "click", () => {
    const simple = document.getElementById("time-simple");
    const detail = document.getElementById("time-detail");
    const btn = document.getElementById("btn-detail-time");
    if (detail.style.display === "none") {
      simple.style.display = "none";
      detail.style.display = "";
      btn.textContent = "おおまかに選ぶ";
    } else {
      detail.style.display = "none";
      simple.style.display = "";
      btn.textContent = "詳細に分かる";
    }
  });

  // Purpose multi-select
  UI.setupMultiCardSelection("#purpose-grid", "purpose", (values) => {
    state.purposes = values;
    saveState();
    const countEl = document.getElementById("purpose-count");
    if (countEl) {
      if (values.length > 0) {
        countEl.textContent = `${values.length}つ選択中`;
        UI.showButton("btn-to-result");
      } else {
        countEl.textContent = "";
        const btn = document.getElementById("btn-to-result");
        if (btn) { btn.classList.remove("btn--visible"); btn.classList.add("btn--hidden"); }
      }
    }
  });

  // === Back navigation ===
  // Flow: Veda Intro → Birthdate → Birthtime → Gender → Marital → Location → Purpose
  on("btn-back-to-veda", "click", () => UI.transitionScreen("screen-birthdate", "screen-veda-intro"));
  on("btn-back-to-birthdate", "click", () => UI.transitionScreen("screen-birthtime", "screen-birthdate"));
  on("btn-back-to-birthtime", "click", () => UI.transitionScreen("screen-gender", "screen-birthtime"));
  on("btn-back-to-gender", "click", () => UI.transitionScreen("screen-marital", "screen-gender"));
  on("btn-back-to-marital", "click", () => UI.transitionScreen("screen-location", "screen-marital"));
  on("btn-back-to-location", "click", () => UI.transitionScreen("screen-purpose", "screen-location"));

  // === Forward navigation ===
  on("btn-start", "click", () => {
    UI.transitionScreen("screen-veda-intro", "screen-birthdate");
  });

  on("btn-to-time", "click", () => {
    state.birthYear = parseInt(document.getElementById("birth-year").value);
    state.birthMonth = parseInt(document.getElementById("birth-month").value);
    state.birthDay = parseInt(document.getElementById("birth-day").value);
    saveState();
    UI.transitionScreen("screen-birthdate", "screen-birthtime");
  });

  on("btn-to-gender", "click", () => UI.transitionScreen("screen-birthtime", "screen-gender"));

  on("btn-skip-time", "click", () => {
    state.timeBlock = null;
    saveState();
    UI.transitionScreen("screen-birthtime", "screen-gender");
  });

  on("btn-to-marital", "click", () => UI.transitionScreen("screen-gender", "screen-marital"));

  on("btn-to-location", "click", () => UI.transitionScreen("screen-marital", "screen-location"));

  on("btn-to-purpose", "click", () => UI.transitionScreen("screen-location", "screen-purpose"));

  on("btn-skip-location", "click", () => {
    state.location = TOKYO_DEFAULT;
    saveState();
    const sel = document.getElementById("location-selected");
    if (sel) { sel.textContent = "東京の座標で計算します"; sel.style.display = "block"; }
    UI.transitionScreen("screen-location", "screen-purpose");
  });

  // Purpose → Loading → Result
  const btnToResult = document.getElementById("btn-to-result");
  let isGenerating = false;
  if (btnToResult) {
    btnToResult.addEventListener("click", () => {
      if (isGenerating) return;
      isGenerating = true;
      btnToResult.disabled = true;
      showLoadingAndResult().finally(() => {
        isGenerating = false;
        btnToResult.disabled = false;
      });
    });
  }

  // Retry
  on("btn-retry", "click", () => {
    state.timeBlock = null;
    state.purposes = [];
    state.location = null;
    state.gender = null;
    state.maritalStatus = null;
    state.childrenCount = null;
    saveState();
    const childWrap = document.getElementById("children-count-wrap");
    if (childWrap) childWrap.style.display = "none";
    const childSelect = document.getElementById("children-count");
    if (childSelect) childSelect.value = "0";
    UI.resetResultAnimations();
    ZodiacWheel.destroy();

    document.querySelectorAll(".card--selected").forEach((c) => c.classList.remove("card--selected"));
    document.querySelectorAll(".btn--visible").forEach((b) => {
      b.classList.remove("btn--visible");
      b.classList.add("btn--hidden");
    });
    const locSearch = document.getElementById("location-search");
    if (locSearch) locSearch.value = "";
    const locSel = document.getElementById("location-selected");
    if (locSel) locSel.style.display = "none";
    const locRes = document.getElementById("location-results");
    if (locRes) locRes.classList.remove("active");
    const purCount = document.getElementById("purpose-count");
    if (purCount) purCount.textContent = "";

    // Ensure loading screen is also hidden and message reset
    const loadingScreen = document.getElementById("screen-loading");
    if (loadingScreen) {
      loadingScreen.classList.remove("screen--active");
      loadingScreen.style.display = "none";
    }
    const loadingMsg = document.getElementById("loading-message");
    if (loadingMsg) loadingMsg.textContent = "ヴェーダの叡智があなたの運命を照らします...";

    UI.hideResultScreen();
    // Return to appropriate start screen
    const intro = document.getElementById("screen-veda-intro") || document.getElementById("screen-welcome");
    if (intro) { intro.style.display = "flex"; intro.classList.add("screen--active"); }
  });

  // === Location search ===
  const locationSearch = document.getElementById("location-search");
  const locationResults = document.getElementById("location-results");
  let searchTimeout = null;

  let apiTimeout = null;

  if (locationSearch) {
    locationSearch.addEventListener("input", () => {
      clearTimeout(searchTimeout);
      clearTimeout(apiTimeout);
      searchTimeout = setTimeout(filterCities, 150);
    });

    locationSearch.addEventListener("focus", () => {
      if (locationSearch.value.trim()) filterCities();
    });
  }

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".location-input-wrap") && locationResults) {
      locationResults.classList.remove("active");
    }
  });

  function renderResults(results) {
    if (results.length === 0) {
      locationResults.classList.remove("active");
      return;
    }

    const hasLocal = results.some(r => r.source === "local");
    const hasApi = results.some(r => r.source === "api");

    locationResults.innerHTML = results.map((r, i) => {
      let separator = "";
      if (hasLocal && hasApi && i > 0 && r.source === "api" && results[i - 1].source === "local") {
        separator = '<div class="location-separator">住所から検索</div>';
      }
      const cls = r.source === "api" ? "location-item location-item--api" : "location-item";
      return `${separator}<div class="${cls}" data-idx="${i}">${r.label}</div>`;
    }).join("");
    locationResults.classList.add("active");

    locationResults.querySelectorAll(".location-item").forEach((item) => {
      item.addEventListener("click", () => {
        const r = results[parseInt(item.dataset.idx)];
        state.location = { name: r.name, lat: r.lat, lng: r.lng, tz: r.tz };
        saveState();
        locationSearch.value = r.name;
        document.getElementById("location-selected").textContent = `${r.name} を選択`;
        document.getElementById("location-selected").style.display = "block";
        locationResults.classList.remove("active");
        UI.showButton("btn-to-purpose");
      });
    });
  }

  function filterCities() {
    const query = locationSearch.value.trim();
    if (!query) {
      locationResults.classList.remove("active");
      return;
    }

    const localResults = Geocoder.searchLocal(query);
    renderResults(localResults);

    clearTimeout(apiTimeout);
    // Skip API if local has an exact/prefix match, or fewer than 2 chars
    const hasExact = Geocoder.hasExactLocalMatch
      ? Geocoder.hasExactLocalMatch(query, localResults)
      : localResults.length >= 3;
    if (query.length >= 2 && localResults.length < 3 && !hasExact) {
      apiTimeout = setTimeout(async () => {
        const apiResults = await Geocoder.searchGeoNames(query);
        const localNames = new Set(localResults.map(r => r.name));
        const filtered = apiResults.filter(r => !localNames.has(r.name));
        if (filtered.length > 0) {
          renderResults([...localResults, ...filtered]);
        }
      }, 400);
    }
  }

  // === Show Result ===
  function timeBlockToHour(tb) {
    if (!tb) return 12;
    const map = {
      morning: 9, afternoon: 15, evening: 0,
      h0: 1, h2: 3, h4: 5, h6: 7, h8: 9, h10: 11,
      h12: 13, h14: 15, h16: 17, h18: 19, h20: 21, h22: 23,
    };
    return map[tb] !== undefined ? map[tb] : 12;
  }

  const PURPOSE_LABELS = {
    love: "恋愛運", career: "仕事運", wealth: "金運",
    health: "健康運", relationships: "人間関係",
  };

  async function showLoadingAndResult() {
    // Reset loading message
    document.getElementById("loading-message").textContent = "ヴェーダの叡智があなたの運命を照らします...";

    // Transition to loading screen
    const purposeScreen = document.getElementById("screen-purpose");
    purposeScreen.classList.remove("screen--active");
    purposeScreen.style.display = "none";

    const loadingScreen = document.getElementById("screen-loading");
    loadingScreen.style.display = "flex";
    loadingScreen.classList.add("screen--active", "screen-enter");
    setTimeout(() => loadingScreen.classList.remove("screen-enter"), 400);

    // Calculate astrology while showing loading
    const loc = state.location || TOKYO_DEFAULT;
    const hour = timeBlockToHour(state.timeBlock);
    let result;
    let ephemerisData = null;

    console.log("[RAVI] === 鑑定開始 ===");
    console.log("[RAVI] 入力:", { ...state, location: loc });

    try {
      const ephStart = performance.now();
      ephemerisData = Ephemeris.calculate(
        state.birthYear, state.birthMonth, state.birthDay,
        hour, 0, loc.lat, loc.lng, loc.tz
      );
      console.log(`[RAVI] 天体計算完了 (${(performance.now() - ephStart).toFixed(0)}ms)`);
      console.log("[RAVI] 惑星位置:", ephemerisData.planets);
      console.log("[RAVI] ラグナ:", ephemerisData.lagna);

      result = Astrology.recommendFromPositions(
        ephemerisData.planets,
        ephemerisData.lagna
      );
    } catch (e) {
      console.warn("[RAVI] 天体計算失敗、フォールバック使用:", e);
      result = Astrology.recommend(
        state.birthMonth, state.birthDay,
        state.timeBlock
      );
    }

    console.log("[RAVI] 鑑定惑星:", result.topPlanet, result.planetNameJp);
    console.log("[RAVI] ラーシ (Janma Rashi):", result.rashi?.name);
    console.log("[RAVI] サブ惑星:", result.secondPlanet, result.thirdPlanet);

    // Vedic nakshatra + Vimshottari Dasha (only available when ephemeris succeeded)
    let nakshatra = null;
    let currentDasha = null;
    if (ephemerisData && ephemerisData.planets.Moon) {
      const moonLon = ephemerisData.planets.Moon.longitude;
      nakshatra = Astrology.getNakshatra(moonLon);
      const birthMs = Date.UTC(state.birthYear, state.birthMonth - 1, state.birthDay, hour, 0) - (loc.tz || 0) * 3600 * 1000;
      const timeline = Astrology.buildDashaTimeline(moonLon, birthMs);
      currentDasha = Astrology.getCurrentDasha(timeline, Date.now());
      console.log("[RAVI] Nakshatra:", nakshatra.nameJp, `第${nakshatra.pada}パーダ`, `支配:${nakshatra.lord}`);
      if (currentDasha && currentDasha.maha) {
        console.log("[RAVI] 現在Dasha:", currentDasha.maha.lord, currentDasha.antar && `- ${currentDasha.antar.lord}`);
      }
    }

    const stoneSeed = Recommendations.makeSeed(state.birthYear, state.birthMonth, state.birthDay, loc.lat, loc.lng);
    const recommendation = Recommendations.getRecommendation(result.topPlanet, stoneSeed);
    const products = Recommendations.getProducts(recommendation);
    const wearingGuide = Recommendations.getWearingGuide(result.topPlanet);
    const recommendedFinger = Recommendations.getRecommendedFinger(recommendation.stone, stoneSeed);
    // 守護石×お悩みで、お悩みカードごとのサジェスト石を解決（購買サジェスト）。
    const concernStones = {};
    (state.purposes || []).forEach((p) => {
      const cs = Recommendations.getConcernStone(recommendation.stone, p);
      if (cs) concernStones[p] = cs;
    });

    console.log("[RAVI] 守護石:", recommendation.stone, `(${recommendation.stoneEn})`);
    console.log("[RAVI] サジェスト石:", Object.entries(concernStones).map(([k, v]) => `${k}:${v.stone}`));

    // Generate fortune reading from template pool (deterministic, no API).
    // Paced to sustain the "the oracle is reading your stars" experience
    // since the underlying computation is near-instant.
    const loadingMsg = document.getElementById("loading-message");
    loadingMsg.textContent = "星の配置を読み解いています...";
    await sleep(900);

    const templateParams = {
      birthYear: state.birthYear,
      birthMonth: state.birthMonth,
      birthDay: state.birthDay,
      gender: state.gender,
      maritalStatus: state.maritalStatus,
      childrenCount: state.childrenCount != null ? state.childrenCount : 0,
      location: loc,
      purposes: state.purposes,
      rashi: result.rashi,
      topPlanet: result.topPlanet,
      planetNameJp: result.planetNameJp,
      stone: recommendation.stone,
      stoneSpiritual: recommendation.spiritual,
      concernStones,
      recommendedFinger,
      wearingBody: wearingGuide ? wearingGuide.body : null,
      wearingDay: wearingGuide ? wearingGuide.day : null,
      wearingTime: wearingGuide ? wearingGuide.time : null,
      nakshatra,
      currentDasha,
    };

    let aiReading;
    try {
      aiReading = TemplateEngine.generate(templateParams);
      console.log("[RAVI] テンプレート生成完了 フィールド:", Object.keys(aiReading));
    } catch (e) {
      console.error("[RAVI] テンプレート生成失敗:", e);
      aiReading = buildFallbackReading(result, recommendation, wearingGuide, recommendedFinger, concernStones);
      console.log("[RAVI] フォールバック使用");
    }

    loadingMsg.textContent = "鑑定結果をまとめています...";
    await sleep(700);

    UI.renderResult(result, recommendation, products, aiReading, wearingGuide, state.purposes, PURPOSE_LABELS, recommendedFinger, { nakshatra, currentDasha });

    loadingScreen.classList.remove("screen--active");
    loadingScreen.style.display = "none";

    UI.showResultScreen();

    let rotationDone = Promise.resolve();
    if (ephemerisData) {
      const rashiIdx = ephemerisData.planets.Sun
        ? ephemerisData.planets.Sun.rashiIndex
        : undefined;
      rotationDone = Zodiac3D.render(
        "zodiac-canvas",
        ephemerisData.planets,
        ephemerisData.lagna,
        result.topPlanet,
        rashiIdx
      );
    }
    UI.animateResultIn(rotationDone);
  }

  function buildFallbackReading(result, recommendation, wearingGuide, recommendedFinger, concernStones) {
    const reading = Recommendations.getRashiReading(result.rashi.id);
    const fallback = Recommendations.getFallbackTimeline(result.rashi.id);
    const stoneUsageText = Recommendations.getStoneUsage(recommendation.stone);

    const concernSuggestions = {};
    (state.purposes || []).forEach((p) => {
      const cs = concernStones && concernStones[p];
      if (!cs) return;
      concernSuggestions[p] = {
        text: `${cs.stone}が、あなたの${PURPOSE_LABELS[p] || ""}をそっと後押ししてくれるでしょう。守護石${recommendation.stone}と重ねて持つことで、その力はさらに深まります。`,
        stone: cs.stone, stoneEn: cs.stoneEn, color: cs.color, image: cs.image, collectionUrl: cs.collectionUrl,
      };
    });

    return {
      personality: reading,
      past: fallback.past,
      present: fallback.present,
      future_year: fallback.future,
      future_beyond: "星の流れは長い時間をかけてあなたを導いています。今の歩みを信じて進み続けることで、やがて大きな実りの時期が訪れるでしょう。焦らず、自分のペースで歩んでいってください。",
      concerns: buildFallbackConcerns(state.purposes, result.rashi),
      concernSuggestions,
      stone_usage: stoneUsageText,
      wearing_guide: wearingGuide ? `守護石を初めて身につける日は、${wearingGuide.day}の${wearingGuide.time}が最も適しています。この時間帯は守護惑星のエネルギーが最も高まるとされ、石との絆が深まりやすいタイミングです。\n\n${recommendedFinger}に着けることで、惑星のエネルギーが最もダイレクトに伝わります。指輪以外では${wearingGuide.body}として肌に近い位置で身につけるのもおすすめです。大きめの石は、より強い惑星のエネルギーを受け取ることができるためおすすめです。\n\n初めて身につける際は、静かな場所で石を手のひらに乗せ、深呼吸をしながら「これから一緒に歩んでいこう」と心の中で語りかけてみてください。石はあなたのエネルギーを記憶し、日々身につけるほどにあなただけのお守りとして力を増していきます。` : "",
    };
  }

  function buildFallbackConcerns(purposes, rashi) {
    const concerns = {};
    const templates = Recommendations.getFallbackConcerns(rashi.id);
    purposes.forEach(p => {
      concerns[p] = templates[p] || "星の導きがあなたを支えています。焦らず、自分のペースで進んでいきましょう。";
    });
    return concerns;
  }
});
